define.alias("ember-math-helpers/helpers/abs", "settings/helpers/abs");